import { post, get } from 'providers/http'

export default {
  methods: {
    async activateAccess (access, scheduled) {
      try {
        await post(`api/v1/mobile-accesses/activate/${access.id}`, { scheduled })

        this.showSuccess('access-activated')
      }
      catch (err) {
        console.error(err)
      }
    },
    async disableAccess (access, scheduled) {
      try {
        await post(`api/v1/mobile-accesses/disable/${access.id}`, { scheduled })

        this.showSuccess('access-disabled')
      }
      catch (err) {
        console.error(err)
      }
    },
    async deleteAccess (access, scheduled) {
      try {
        await post(`api/v1/mobile-accesses/delete/${access.id}`, { scheduled })

        this.showSuccess('access-deleted')
      }
      catch (err) {
        console.error(err)
      }
    },
    getPendingAccesses () {
      return get('api/v1/mobile-accesses/pending')
    }
  }
}



// WEBPACK FOOTER //
// ./src/service/api.js